module.exports = __webpack_public_path__ + "img/25.e97867a2.jpg";